import { useEffect, useRef } from "react";
import { useAppDispatch } from "../../../store/hooks";
import { fetchNotifications } from "../thunks/notifications.thunk";

const NOTIFICATION_FETCH_THROTTLE_MS = 45 * 1000; // 45 seconds

/**
 * When the notification dropdown is open, fetches notifications at most once per throttle window.
 * to avoid repeated API calls when the dropdown stays open or is reopened quickly.
 */
export function useThrottledNotificationFetch(isDropdownOpen: boolean) {
  const dispatch = useAppDispatch();
  const lastFetchedAtRef = useRef<number | null>(null);

  useEffect(() => {
    if (!isDropdownOpen) return;

    const now = Date.now();
    const last = lastFetchedAtRef.current;
    if (last != null && now - last < NOTIFICATION_FETCH_THROTTLE_MS) {
      return;
    }

    lastFetchedAtRef.current = now;
    dispatch(fetchNotifications());
  }, [isDropdownOpen, dispatch]);
}
